import { inject, type InjectionKey } from 'vue';
import type { AnalyticsClient, AnalyticsEventsMap } from '@satellite/analytics/AnalyticsClient';
export type {
  AnalyticsClient,
  AnalyticsEventPayload,
  AnalyticsEventsMap,
  TrackOptions
} from '@satellite/analytics/AnalyticsClient';

/**
 * Injection key used by app-level providers.
 * The map is specialized at call site via useAnalytics<EventsMap>().
 */
export const analyticsKey: InjectionKey<AnalyticsClient<AnalyticsEventsMap>> = Symbol('analytics');

/**
 * Returns the analytics client provided by the app.
 *
 * @throws Error if analytics client was not provided
 */
export function useAnalytics<
  E extends AnalyticsEventsMap = AnalyticsEventsMap
>(): AnalyticsClient<E> {
  const client = inject(analyticsKey) as AnalyticsClient<E> | undefined;

  if (!client) {
    throw new Error('Missing analytics client provider');
  }

  return client;
}
